import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { App } from './App';
import { GraphingPorfolio } from './graphing';
import { Technology } from './Technology';
import { Writing } from './Writing';
import { Work } from './Work';
import { GIS } from './gis';
import { Graphics } from './graphics.tsx';

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/graphing' element={<GraphingPorfolio/>} />
        <Route path='/tech' element={<Technology/>} />
        <Route path='/writing' element={<Writing/>} /> 
        <Route path='/work' element={<Work/>} />
        <Route path='/gis' element={<GIS/>} />
        <Route path='/graphics' element={<Graphics/>} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
